import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxTextAreaModule } from 'devextreme-angular/ui/text-area';
import Footer from './ui/footer/footer';
import Header from './ui/header/header';

@Component({
  selector: 'app-root',
  imports: [
    DxFormModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxLoadIndicatorModule,
    DxPopupModule,
    RouterOutlet,
    Header,
    Footer,
  ],
  template: `
    <app-header />
    <main class="app-main">
      <router-outlet />
    </main>
    <app-footer />
  `,
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class App {}
